<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <div class="generalcontainerplanes" style="text-align: initial">
            <!---Generall planes---->
            <div class="generalcontainerplanes">
                <h5>Tratamientos</h5>

                <div class="row"><!----Inicio bloque b------->




                </div><!---fin bloque b--->

                <!--Lista de tratamientos--->
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <b-card class="cardMaximo" no-body header="Tratamientos">
                            <b-row>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <b-form-group label="Categorias:" label-for="Categorias">
                                        <v-select
                                                id="Categorias"
                                                value="idCategoria"
                                                label="descripcion"
                                                v-model="categoria"
                                                :options="categorias"
                                                @input="filtrarLista()"
                                                required
                                        ></v-select>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <b-form-group label="Nombre tratamiento:" label-for="trt">
                                        <b-form-input
                                                id="trt"
                                                placeholder="Nombre de tratamiento"
                                                v-model="nombreFiltro"
                                                @keyup="filtrarLista"
                                                type="text"
                                                required
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                            </b-row>
                            <b-list-group class="overflow-auto" flush>
                                <b-list-group-item v-for="t in tratamientos" :key="t.nombre+t.idTratamiento"
                                                   @click="agregarConfig(t)" href="#">
                                    {{t.nombre}}
                                    <b-button v-if="!t.seleccionado" variant="outline-primary" class="float-lg-right">
                                        <em
                                                class="fa fa-plus-circle"></em></b-button>
                                </b-list-group-item>
                            </b-list-group>
                        </b-card>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <b-card v-if="tratamientosConfig.length > 0" class="cardMaximo" no-body header="Configuración">
                            <div class="row"><!----Inicio bloque a------->

                                <div class="col-lg-6 col-md-6 col-sm-12">

                                    <b-form-group label="Descuentos: %" label-for="decuentotratamiento ">
                                        <b-form-input
                                                size="sm"
                                                id="decuentotratamiento"
                                                v-model="decuentotratamiento"
                                                type="number"
                                                required
                                        ></b-form-input>
                                    </b-form-group>

                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-12">

                                    <b-form-group label="Descuento Especial: %"
                                                  label-for="descuentoespecialtratamiento">
                                        <b-form-input
                                                size="sm"
                                                id="descuentoespecialtratamiento"
                                                v-model="descuentoespecialtratamiento"
                                                type="number"
                                                required
                                        ></b-form-input>
                                    </b-form-group>

                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-12">

                                    <b-form-group label="Número de veces al año: " label-for="numeroveces">
                                        <b-form-input
                                                size="sm"
                                                id="numeroveces"
                                                v-model="numeroveces"
                                                type="number"
                                                required
                                        ></b-form-input>
                                    </b-form-group>

                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">

                                    <b-form-group label="Descuentos por default: %"
                                                  label-for="decuentodefault">
                                        <b-form-input
                                                id="numeroveces"
                                                v-model="decuentodefault"
                                                type="number"
                                                required
                                        ></b-form-input>
                                        <span class="glyphicon glyphicon-user form-control-feedback"></span>
                                    </b-form-group>

                                </div>
                                <div class="col-12">
                                    <b-button block variant="outline-primary" @click="agregarASeleccionados()">
                                        Guardar
                                    </b-button>
                                </div>
                            </div><!---Final del div bloqur a--->
                            <b-list-group class="overflow-auto" flush>
                                <b-list-group-item v-for="t in tratamientosConfig" :key="t.nombre+t.idTratamiento"
                                                   href="#">
                                    {{t.nombre}}
                                    <b-button variant="danger" @click="eliminarTratamiento(t)" class="float-lg-right">
                                        <em
                                                class="fa fa-close"></em></b-button>
                                </b-list-group-item>

                            </b-list-group>

                        </b-card>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <b-card v-if="tratamientosSeleccionados.length > 0" class="cardMaximo" no-body
                                header="Tratamientos seleccionados">
                            <b-list-group class="overflow-auto" flush>
                                <b-list-group-item v-for="t in tratamientosSeleccionados"
                                                   :key="t.nombre+t.idTratamiento"
                                                   href="#">
                                    {{+t.descuento +'% ' + t.nombre}}
                                    <b-button @click="eliminarTratamientoSeleciionado(t)" variant="danger"
                                              class="float-lg-right"><em class="fa fa-close"></em>
                                    </b-button>
                                </b-list-group-item>
                            </b-list-group>
                        </b-card>
                    </div>

                </div>
                <hr>
                <b-row>
                    <b-col>
                        <h3>Grupo de tratamientos</h3>
                    </b-col>
                </b-row>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <b-card class="cardMaximo" no-body header="Grupos">
                            <b-row>
                                <b-col>
                                    <b-button v-b-tooltip.hover title="Crear nuevo grupo" variant="outline-success"
                                              @click="abrirModal()"
                                    >Crear Grupo
                                    </b-button>
                                </b-col>
                            </b-row>
                            <b-row>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <b-form-group label="Nombre del grupo:" label-for="trt">
                                        <b-form-input
                                                id="trt"
                                                placeholder="Nombre del grupo"
                                                v-model="nombreFiltroGrupo"
                                                @keyup="filtrarListaGrupo"
                                                type="text"
                                                required
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                            </b-row>
                            <b-list-group class="overflow-auto" flush>
                                <b-list-group-item v-for="t in grupos" :key="t.nombre+t.idTratamientoGrupo"
                                                   @click="agregarConfigGrupo(t)" href="#">
                                    {{t.nombre}}
                                    <b-button v-if="!t.seleccionado" variant="outline-primary" class="float-lg-right">
                                        <em  class="fa fa-plus-circle"></em></b-button>
                                </b-list-group-item>
                            </b-list-group>
                        </b-card>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <b-card v-if="gruposConfig.length > 0" class="cardMaximo" no-body header="Configuración">
                            <div class="row"><!----Inicio bloque a------->

                                <div class="col-lg-6 col-md-6 col-sm-12">

                                    <b-form-group label="Descuentos: %" label-for="decuentotratamiento ">
                                        <b-form-input
                                                size="sm"
                                                id="decuentotratamiento"
                                                v-model="decuentotratamientoGrupo"
                                                type="number"
                                                required
                                        ></b-form-input>
                                    </b-form-group>

                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-12">

                                    <b-form-group label="Descuento Especial: %"
                                                  label-for="descuentoespecialtratamiento">
                                        <b-form-input
                                                size="sm"
                                                id="descuentoespecialtratamiento"
                                                v-model="descuentoespecialtratamientoGrupo"
                                                type="number"
                                                required
                                        ></b-form-input>
                                    </b-form-group>

                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-12">

                                    <b-form-group label="Número de veces al año: " label-for="numeroveces">
                                        <b-form-input
                                                size="sm"
                                                id="numeroveces"
                                                v-model="numerovecesGrupo"
                                                type="number"
                                                required
                                        ></b-form-input>
                                    </b-form-group>

                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">

                                    <b-form-group label="Descuentos por default: %"
                                                  label-for="decuentodefault">
                                        <b-form-input
                                                id="numeroveces"
                                                v-model="decuentodefaultGrupo"
                                                type="number"
                                                required
                                        ></b-form-input>
                                        <span class="glyphicon glyphicon-user form-control-feedback"></span>
                                    </b-form-group>

                                </div>
                                <div class="col-12">
                                    <b-button block variant="outline-primary" @click="agregarASeleccionadosGrupos()">
                                        Guardar
                                    </b-button>
                                </div>
                            </div>
                            <b-list-group class="overflow-auto" flush>
                                <b-list-group-item v-for="t in gruposConfig" :key="t.nombre+t.idTratamientoGrupo+'conf'"
                                                   href="#">
                                    {{t.nombre}}
                                    <b-button variant="danger" @click="eliminarGrupo(t)" class="float-lg-right">
                                        <em
                                                class="fa fa-close"></em></b-button>
                                </b-list-group-item>

                            </b-list-group>

                        </b-card>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <b-card v-if="gruposSeleccionados.length > 0" class="cardMaximo" no-body
                                header="Grupos seleccionados">
                            <b-list-group class="overflow-auto" flush>
                                <b-list-group-item v-for="t in gruposSeleccionados"
                                                   :key="t.nombre+t.idTratamientoGrupo"
                                                   href="#">
                                    {{+t.descuento +'% ' + t.nombre}}
                                    <b-button @click="eliminarTratamientoSeleciionado(t)" variant="danger"
                                              class="float-lg-right"><em class="fa fa-close"></em>
                                    </b-button>
                                </b-list-group-item>
                            </b-list-group>
                        </b-card>
                    </div>

                </div>

            </div>

        </div><!---Generalplanes--->

        <b-modal
                v-model="showModal"
                title="Crear nuevo grupo"
                size="lg"
        >
            <b-container fluid>
                <b-row>
                    <b-col>
                        <b-form>
                            <b-form-group align="left">
                                <label for="nombreGrupo">Nombre
                                    <validacion />
                                </label>
                                <b-input-group size="sm" class="mb-2">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="menu-button-wide"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input id="nombrePerfil" name="nombreMenu" placeholder="Nombre del perfil"
                                                  v-model="nuevoGrupo.nombre"
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group align="left">
                                <label for="trtsg">Tratamientos</label>
                                <validacion />
                                <b-input-group size="sm" class="mb-2">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="menu-button-wide-fill"></b-icon>
                                    </b-input-group-prepend>
                                    <v-select id="trtsg" name="trtsg"
                                              placeholder="Tratamientos"
                                              multiple
                                              v-model="nuevoGrupo.tratamientos"
                                              label="nombre"
                                              :options="tatamientosParaGrupos"
                                              style="width: 95%"
                                    ></v-select>
                                </b-input-group>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
            </b-container>
            <div slot="modal-footer">
                <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardarGrupo()">
                    <span v-if="!loaderAcciones">Guardar</span>
                    <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
                </b-button>
                <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
            </div>
        </b-modal>

        <br>
        <b-button variant="primary" @click="atras('four', 'third')"><em
                class="fa fa-chevron-left"></em> Atras
        </b-button>
        <b-button variant="primary" @click="adelante('four', 'five')">Siguente <em
                class="fa fa-chevron-right"></em>
        </b-button>
    </div>

</template>

<script>
    export default {
        props: ['idPlan'],
        name: "tratamientos",
        data: () => {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,

                categorias: [],
                categoria: null,
                nombreFiltro: null,
                nombreFiltroGrupo: null,
                tatamientosParaGrupos: [],
                tratamientos: [],
                tratamientosBK: [],
                tratamientosConfig: [],
                grupos: [],
                gruposBK: [],
                gruposConfig: [],
                tratamientosSeleccionados: [],
                gruposSeleccionados: [],
                decuentotratamiento: null,
                descuentoespecialtratamiento: null,
                numeroveces: null,
                decuentotratamientoGrupo: null,
                descuentoespecialtratamientoGrupo: null,
                numerovecesGrupo: null,
                decuentodefault: null,
                nuevoGrupo: {
                    nombre: null,
                    tratamientos: []
                },
                loaderAcciones : false,
                showModal : false
            }
        },
        created() {
          this.debug = this.$localStorageService.getDebug();
            this.obtenerCategorias();
            this.obtenerTratamientosPorCategoria();
            this.obtenerTratamientosPorPlan();
            this.obtenerGrupossPorPlan();
            this.obtenerGrupos();
        },
        methods: {
            obtenerCategorias() {
                this.$http.get(this.$api + 'catalogos/listaCategorias').then(
                    respuesta => {
                        if (respuesta.data.data) {
                            respuesta.data.data.forEach(it => {
                                this.categorias.push(it)
                            })
                        }

                    }
                )
            },
            obtenerGrupos() {
                this.$http.get(this.$api + 'catalogos/listaTratamientosGrupos').then(
                    respuesta => {
                        if (respuesta.data.data) {

                            this.grupos = respuesta.data.data
                            this.gruposBK = respuesta.data.data
                            this.validarSeleccionadosGrupo();
                        }

                    }
                )
            },
            obtenerTratamientosPorCategoria() {
                this.$http.get(this.$api + 'planConvenio/obtener/tratamientos/categoria').then(
                    respuesta => {
                        if (respuesta.data.data) {
                            this.tratamientos = respuesta.data.data;
                            this.tatamientosParaGrupos = JSON.parse(JSON.stringify(respuesta.data.data));
                            this.tratamientosBK = JSON.parse(JSON.stringify(respuesta.data.data));
                            this.validarSeleccionados();
                        }

                    }
                )
            },
            obtenerTratamientosPorPlan() {
                if (this.idPlan !== undefined) {
                    const parametros = {idPlan: this.idPlan}
                    this.$http.post(this.$api + 'planConvenio/obtenerTratamientosplan', parametros).then(
                        respuesta => {
                            if (respuesta.data.data) {
                                this.tratamientosSeleccionados = respuesta.data.data;
                                this.validarSeleccionados();
                            }
                        }
                    )
                }
            },
            obtenerGrupossPorPlan() {
                if (this.idPlan !== undefined) {
                    const parametros = {idPlan: this.idPlan}
                    this.$http.post(this.$api + 'planConvenio/obtenerGruposplan', parametros).then(
                        respuesta => {
                            if (respuesta.data.data) {
                                this.gruposSeleccionados = respuesta.data.data;
                                this.validarSeleccionadosGrupo();
                            }
                        }
                    )
                }
            },
            validarSeleccionados() {
                this.tratamientos.forEach(it => {
                    this.tratamientosSeleccionados.forEach(t => {
                        if (t.idTratamiento === it.idTratamiento) {
                            it.seleccionado = true;
                        }
                    })
                })
                this.tratamientosBK.forEach(it => {
                    this.tratamientosSeleccionados.forEach(t => {
                        if (t.idTratamiento === it.idTratamiento) {
                            it.seleccionado = true;
                        }
                    })
                })

            },
            validarSeleccionadosGrupo() {
                this.grupos.forEach(it => {
                    this.gruposSeleccionados.forEach(t => {
                        if (t.idTratamientoGrupo === it.idTratamientoGrupov) {
                            it.seleccionado = true;
                        }
                    })
                })
                this.gruposBK.forEach(it => {
                    this.gruposSeleccionados.forEach(t => {
                        if (t.idTratamientoGrupo === it.idTratamientoGrupo) {
                            it.seleccionado = true;
                        }
                    })
                })

            },
            agregarConfig(t) {
                if (!t.seleccionado) {
                    t.seleccionado = true;
                    this.tratamientosConfig.push(t);
                }
            },
            agregarConfigGrupo(t) {
                if (!t.seleccionado) {
                    t.seleccionado = true;
                    this.gruposConfig.push(t);
                }
            },
            agregarASeleccionados() {
                this.tratamientosConfig.forEach(it => {
                    it.descuento = this.decuentotratamiento;
                    it.descuentoEspecial = this.descuentoespecialtratamiento;
                    it.numeroveces = this.numeroveces;
                    this.tratamientosSeleccionados.push(it)
                })

                this.tratamientosConfig = [];
                this.reiniciarDescuentos()
            },
            agregarASeleccionadosGrupos() {
                this.gruposConfig.forEach(it => {
                    it.descuento = this.decuentotratamientoGrupo;
                    it.descuentoEspecial = this.descuentoespecialtratamientoGrupo;
                    it.numeroveces = this.numerovecesGrupo;
                    this.gruposSeleccionados.push(it)
                })

                this.gruposConfig = [];
                this.reiniciarDescuentosGrupos()
            },
            eliminarTratamiento(item) {
                this.tratamientos.forEach(it => {
                    if (it.idTratamiento === item.idTratamiento) {
                        it.seleccionado = false;
                    }
                })
                this.tratamientosConfig.splice(this.tratamientosConfig.indexOf(item), 1);
                if (this.tratamientosConfig.length === 0) {
                    this.reiniciarDescuentos()
                }

            },
            eliminarGrupo(item) {
                this.grupos.forEach(it => {
                    if (it.idTratamientoGrupo === item.idTratamientoGrupo) {
                        it.seleccionado = false;
                    }
                })
                this.tgruposConfig.splice(this.gruposConfig.indexOf(item), 1);
                if (this.gruposConfig.length === 0) {
                    this.reiniciarDescuentos()
                }

            },
            eliminarTratamientoSeleciionado(item) {
                this.$swal({
                    icon: "warning",
                    text: "¿Está seguro de eliminar el tratamiento ?",
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    showCancelButton: true,
                    showConfirmButton: true,
                }).then((aceptar) => {
                    if (aceptar.value) {
                        this.tratamientos.forEach(it => {
                            if (it.idTratamiento === item.idTratamiento) {
                                it.seleccionado = false;
                            }
                        });
                        this.tratamientosSeleccionados.splice(this.tratamientosSeleccionados.indexOf(item), 1);
                    }
                });
            },
            reiniciarDescuentos() {
                this.decuentotratamiento = null;
                this.descuentoespecialtratamiento = null;
                this.numeroveces = null;
            },
            reiniciarDescuentosGrupos() {
                this.decuentotratamientoGrupo = null;
                this.descuentoespecialtratamientoGrupo = null;
                this.numerovecesGrupo = null;
            },
            atras(uno, dos) {
                this.$emit('set-Done', uno, dos)
            },
            adelante(uno, dos) {
                const parametros = {idPlan: this.idPlan, lista: this.tratamientosSeleccionados}
                this.$http.post(this.$api + 'planConvenio/tratamientos/guardar', parametros).then(respuesta => {
                    if (respuesta.data.data) {
                        this.$emit('set-Done', uno, dos)
                    }

                })
                this.gruposSeleccionados.idPlan = this.idPlan;
                this.$http.post(this.$api + 'planConvenio/grupos/guardar', this.gruposSeleccionados)
                .then(respuesta => {
                    if (respuesta.data.data) {
                        this.$emit('set-Done', uno, dos)
                    }

                })

            },
            filtrarLista() {
                this.validarSeleccionados();
                this.tratamientos = this.tratamientosBK.filter(it => {
                    return ((this.categoria === null || it.idcategoria === this.categoria.idCategoria) && it.nombre.toLowerCase().includes(this.nombreFiltro.toLowerCase()))
                });

            },
            filtrarListaGrupo() {
                this.validarSeleccionadosGrupo();
                this.grupos = this.gruposBK.filter(it => {
                    return (it.nombre.toLowerCase().includes(this.nombreFiltroGrupo.toLowerCase()))
                });

            },
            abrirModal(){
                this.showModal = true;
                this.nuevoGrupo = {
                    nombre: null,
                    tratamientos: []
                }
            },
            cerrarModal(){
                this.show = false;
            },
            guardarGrupo(){
                this.$http.post(this.$api + 'planConvenio/guardar/grupo?idPlan=' + this.idPlan, this.nuevoGrupo).then(respuesta => {
                    if (respuesta.data.data) {
                        this.obtenerGrupos();
                        this.showModal = false;
                    }

                })
            }
        }
    }
</script>

<style scoped>
    .cardMaximo {
        min-height: 500px;
        max-height: 500px;
    }
</style>
